import {
    SiSpringboot, SiNextdotjs, SiPostgresql, SiTailwindcss, SiDotnet, SiSqlite,
    SiNestjs, SiPrisma, SiSocketdotio, SiJavascript, SiLaravel, SiMysql,
    SiOpencv, SiPython, SiQt, SiSoundcloud, SiTensorflow, SiReact, SiExpress,
    SiMongodb, SiDocker, SiGit, SiFigma, SiRedux, SiJest, SiFlutter, SiVite,
    SiGithubactions, SiTypescript, SiNodedotjs, SiFramer, SiHive, SiFirebase,
    SiMaterialdesign,
    SiBotblecms,
    SiGodotengine
} from "react-icons/si";
import { TbBrandCSharp, TbChess } from "react-icons/tb";
import { FaJava, FaNodeJs, FaTools, FaReact } from "react-icons/fa";
import { FiDatabase, FiTerminal, FiLayers } from "react-icons/fi";
import { translations } from "./translations";
import { BotIcon } from "lucide-react";

// Fonction pour obtenir les compétences
const getSkills = (lang: 'fr' | 'en' = 'fr') => {
    const t = translations[lang];

    return [
        {
            category: t.skills.categories.languages,
            icon: <FiLayers className="w-5 h-5" />,
            description: t.technologies.descriptions.frontend,
            items: [
                {
                    name: "TypeScript",
                    icon: <SiTypescript />,
                    color: "text-blue-600",
                    desc: "Superset JavaScript typé."
                },
                {
                    name: "Java",
                    icon: <FaJava />,
                    color: "text-red-500",
                    desc: "Langage orienté objet robuste."
                },
                {
                    name: "C#",
                    icon: <TbBrandCSharp />,
                    color: "text-primary",
                    desc: "Langage polyvalent Microsoft."
                },
                {
                    name: "Python",
                    icon: <SiPython />,
                    color: "text-blue-500",
                    desc: "Langage pour IA et Scripting."
                },
            ],
        },
        {
            category: t.skills.categories.frontend,
            icon: <FiLayers className="w-5 h-5" />,
            description: t.technologies.descriptions.frontend,
            items: [
                {
                    name: "Next.js",
                    icon: <SiNextdotjs />,
                    color: "text-black dark:text-white",
                    desc: t.technologies.items.nextjs.desc
                },
                {
                    name: "Tailwind",
                    icon: <SiTailwindcss />,
                    color: "text-cyan-500",
                    desc: t.technologies.items.tailwind.desc
                },
                {
                    name: "Flutter",
                    icon: <SiFlutter />,
                    color: "text-blue-400",
                    desc: t.technologies.items.flutter.desc
                }
            ],
        },
        {
            category: t.skills.categories.backend,
            icon: <FiTerminal className="w-5 h-5" />,
            description: t.technologies.descriptions.backend,
            items: [
                {
                    name: "Spring Boot",
                    icon: <SiSpringboot />,
                    color: "text-green-600",
                    desc: t.technologies.items.springboot.desc
                },
                {
                    name: "NestJS",
                    icon: <SiNestjs />,
                    color: "text-red-600",
                    desc: t.technologies.items.nestjs.desc
                },
                {
                    name: "Laravel",
                    icon: <SiLaravel />,
                    color: "text-red-500",
                    desc: t.technologies.items.laravel.desc
                },
                {
                    name: ".NET",
                    icon: <SiDotnet />,
                    color: "text-primary",
                    desc: "Framework de développement."
                },
            ],
        },
        {
            category: t.skills.categories.data,
            icon: <FiDatabase className="w-5 h-5" />,
            description: t.technologies.descriptions.database,
            items: [
                {
                    name: "PostgreSQL",
                    icon: <SiPostgresql />,
                    color: "text-blue-400",
                    desc: t.technologies.items.postgresql.desc
                },
                {
                    name: "MySQL",
                    icon: <SiMysql />,
                    color: "text-orange-500",
                    desc: t.technologies.items.mysql.desc
                },
                {
                    name: "SQLite",
                    icon: <SiSqlite />,
                    color: "text-blue-400",
                    desc: "Base de données légère."
                },
            ],
        },
        {
            category: t.skills.categories.devops,
            icon: <FaTools className="w-5 h-5" />,
            description: t.technologies.descriptions.devops,
            items: [
                {
                    name: "Docker",
                    icon: <SiDocker />,
                    color: "text-blue-500",
                    desc: t.technologies.items.docker.desc
                },
                {
                    name: "Git",
                    icon: <SiGit />,
                    color: "text-orange-500",
                    desc: t.technologies.items.git.desc
                },
                {
                    name: "Figma",
                    icon: <SiFigma />,
                    color: "text-primary",
                    desc: t.technologies.items.figma.desc
                },
                {
                    name: "GitHub Actions",
                    icon: <SiGithubactions />,
                    color: "text-blue-600",
                    desc: "Automatisation de workflow."
                },
            ],
        },
    ];
};

// Fonction pour obtenir tous les projets
const getAllProjects = (lang: 'fr' | 'en' = 'fr') => {
    const t = translations[lang];

    return [
        // REGION
        {
            id: 1,
            title: t.projectsData.regionDiana.title,
            description: t.projectsData.regionDiana.description,
            detailedDescription: t.projectsData.regionDiana.detailedDescription,
            technologies: [
                {
                    id: 0,
                    icon: <SiNextdotjs size="1.5rem" title="Next.js" />,
                    name: "Next.js"
                },
                {
                    id: 1,
                    icon: <SiSpringboot size="1.5rem" title="Spring Boot" />,
                    name: "Spring Boot"
                },
                {
                    id: 2,
                    icon: <SiPostgresql size="1.5rem" title="PostgreSQL" />,
                    name: "PostgreSQL"
                },
                {
                    id: 3,
                    icon: <SiTypescript size="1.5rem" title="TypeScript" />,
                    name: "TypeScript"
                },
            ],
            imageUrl: "/region/illustration_region.webp",
            images: [
                {
                    id: 0,
                    src: "/region/auth_1.webp",
                },
                {
                    id: 1,
                    src: "/region/auth_2.webp",
                },
                {
                    id: 2,
                    src: "/region/dashboard.webp",
                },
                {
                    id: 3,
                    src: "/region/light.webp",
                },
                {
                    id: 4,
                    src: "/region/responsive.webp",
                },
                {
                    id: 5,
                    src: "/region/form.webp",
                }
            ],
            projectUrl: "/projects/1",
            liveUrl: "https://front-client-region-8vbl3y0nh-emmanuelalexis-projects.vercel.app/",
            githubLinks: [],
            access: "protected",
            featured: true,
            date: "2024-10"
        },
        // Room App
        {
            id: 2,
            title: t.projectsData.roomApp.title,
            description: t.projectsData.roomApp.description,
            detailedDescription: t.projectsData.roomApp.detailedDescription,
            technologies: [
                {
                    id: 0,
                    icon: <SiNextdotjs size="1.5rem" title="Next.js" />,
                    name: "Next.js"
                },
                {
                    id: 1,
                    icon: <SiNestjs size="1.5rem" title="NestJS" />,
                    name: "NestJS"
                },
                {
                    id: 2,
                    icon: <SiSocketdotio size="1.5rem" title="Socket.IO" />,
                    name: "Socket.IO"
                },
                {
                    id: 3,
                    icon: <SiTailwindcss size="1.5rem" title="TailwindCSS" />,
                    name: "TailwindCSS"
                },
                {
                    id: 4,
                    icon: <SiFramer size="1.5rem" title="Framer Motion" />,
                    name: "Framer Motion"
                },
                {
                    id: 5,
                    icon: <SiTypescript size="1.5rem" title="TypeScript" />,
                    name: "TypeScript"
                },
            ],
            imageUrl: "/room/home.webp",
            images: [
                {
                    id: 0,
                    src: "/room/home.webp",
                },
                {
                    id: 1,
                    src: "/room/dashboard.webp",
                },
                {
                    id: 2,
                    src: "/room/discussion.webp",
                }
            ],
            projectUrl: "/projects/2",
            liveUrl: "",
            githubLinks: [
                { label: "Frontend", url: "https://github.com/emmanuelAlexis/room-app.git" },
                { label: "Backend", url: "https://github.com/emmanuelAlexis/room-app-backend.git" }
            ],
            access: "public",
            featured: true,
            date: "2024-11"
        },
        // Starter
        {
            id: 3,
            title: t.projectsData.nextFrontStarter.title,
            description: t.projectsData.nextFrontStarter.description,
            detailedDescription: t.projectsData.nextFrontStarter.detailedDescription,
            technologies: [
                {
                    id: 0,
                    icon: <SiNextdotjs size="1.5rem" title="Next.js" />,
                    name: "Next.js"
                },
                {
                    id: 1,
                    icon: <SiReact size="1.5rem" title="React" />,
                    name: "React"
                },
                {
                    id: 2,
                    icon: <SiTypescript size="1.5rem" title="TypeScript" />,
                    name: "TypeScript"
                },
                {
                    id: 3,
                    icon: <SiTailwindcss size="1.5rem" title="TailwindCSS" />,
                    name: "TailwindCSS"
                },
                {
                    id: 4,
                    icon: <SiFramer size="1.5rem" title="Framer Motion" />,
                    name: "Framer Motion"
                },
            ],
            imageUrl: "/starter/illustration_starter.webp",
            images: [
                {
                    id: 0,
                    src: "/starter/illustration_starter.webp",
                },
                {
                    id: 1,
                    src: "/starter/home.webp",
                },
            ],
            projectUrl: "/projects/3",
            liveUrl: "https://next-theme-starter-docs.vercel.app/",
            githubLinks: [
                { label: "Template", url: "https://github.com/emmanuelAlexis/next_front_startup_with_dark_mode.git" }
            ],
            access: "public",
            featured: true,
            date: "2024-09"
        },
        // Mofidra
        {
            id: 4,
            title: t.projectsData.globydep.title,
            description: t.projectsData.globydep.description,
            detailedDescription: t.projectsData.globydep.detailedDescription,
            technologies: [
                {
                    id: 0,
                    icon: <SiFlutter size="1.5rem" title="Flutter" />,
                    name: "Flutter"
                },
                {
                    id: 1,
                    icon: <SiHive size="1.5rem" title="Hive" />,
                    name: "Hive"
                },
                {
                    id: 2,
                    icon: <SiFirebase size="1.5rem" title="Firebase" />,
                    name: "Firebase"
                },
            ],
            imageUrl: "/globydep/illustration_1.webp",
            images: [
                {
                    id: 0,
                    src: "/globydep/illustration_1.webp",
                },
                {
                    id: 1,
                    src: "/globydep/weeks.jpg",
                },
                {
                    id: 2,
                    src: "/globydep/loans.jpg",
                },
                {
                    id: 3,
                    src: "/globydep/profil.jpg",
                }
            ],
            projectUrl: "/projects/4",
            liveUrl: "",
            githubLinks: [],
            access: "private",
            featured: true,
            date: "2024-12"
        },
        // Biblio
        {
            id: 5,
            title: t.projectsData.biblio.title,
            description: t.projectsData.biblio.description,
            detailedDescription: t.projectsData.biblio.detailedDescription,
            technologies: [
                {
                    id: 0,
                    icon: <SiNextdotjs size="1.5rem" title="Next.js" />,
                    name: "Next.js"
                },
                {
                    id: 1,
                    icon: <SiSpringboot size="1.5rem" title="Spring Boot" />,
                    name: "Spring Boot"
                },
                {
                    id: 2,
                    icon: <SiPostgresql size="1.5rem" title="PostgreSQL" />,
                    name: "PostgreSQL"
                },
                {
                    id: 3,
                    icon: <SiTailwindcss size="1.5rem" title="TailwindCSS" />,
                    name: "TailwindCSS"
                },
                {
                    id: 4,
                    icon: <FaJava size="1.5rem" title="Java" />,
                    name: "Java"
                },
            ],
            imageUrl: "/biblio/illustration_2.webp",
            images: [
                {
                    id: 0,
                    src: "/biblio/home.webp",
                },
                {
                    id: 1,
                    src: "/biblio/catalogue.webp",
                },
                {
                    id: 2,
                    src: "/biblio/infos.webp",
                },
                {
                    id: 3,
                    src: "/biblio/discuss.webp",
                },
                {
                    id: 4,
                    src: "/biblio/lecture.webp",
                },
                {
                    id: 5,
                    src: "/biblio/space.webp",
                },
                {
                    id: 6,
                    src: "/biblio/add.webp",
                },
            ],
            projectUrl: "/projects/5",
            liveUrl: "",
            githubLinks: [
                { label: "Frontend", url: "https://github.com/emmanuelAlexis/FRONT_BIBLIO.git" },
                { label: "Backend", url: "https://github.com/emmanuelAlexis/BACK_BIBLIO.git" }
            ],
            access: "public",
            featured: true,
            date: "2024-11"
        },
        // Chess
        {
            id: 6,
            title: t.projectsData.chessAssist.title,
            description: t.projectsData.chessAssist.description,
            detailedDescription: t.projectsData.chessAssist.detailedDescription,
            technologies: [
                {
                    id: 0,
                    icon: <SiNextdotjs size="1.5rem" title="Next.js" />,
                    name: "Next.js"
                },
                {
                    id: 1,
                    icon: <SiReact size="1.5rem" title="React" />,
                    name: "React"
                },
                {
                    id: 2,
                    icon: <SiTypescript size="1.5rem" title="TypeScript" />,
                    name: "TypeScript"
                },
                {
                    id: 3,
                    icon: <TbChess size="1.5rem" title="chess.js" />,
                    name: "chess.js"
                },
                {
                    id: 4,
                    icon: <SiFramer size="1.5rem" title="Framer Motion" />,
                    name: "Framer Motion"
                },
                {
                    id: 5,
                    icon: <SiTailwindcss size="1.5rem" title="TailwindCSS" />,
                    name: "TailwindCSS"
                },
                {
                    id: 6,
                    icon: <SiGodotengine size="1.5rem" title="AI" />,
                    name: "AI"
                },
            ],
            imageUrl: "/chess/illustration_1.webp",
            images: [
                {
                    id: 0,
                    src: "/chess/home.webp",
                },
                {
                    id: 1,
                    src: "/chess/game.webp",
                },
                {
                    id: 2,
                    src: "/chess/dark.webp",
                }
            ],
            projectUrl: "/projects/6",
            liveUrl: "https://chess-assistantio.vercel.app/",
            githubLinks: [
                { label: "Frontend", url: "https://github.com/emmanuelAlexis/chessAssistant.git" }
            ],
            access: "public",
            featured: true,
            date: "2025-11"
        },

    ];
};

const getFeaturedProjects = (lang: 'fr' | 'en' = 'fr') => {
    const allProjects = getAllProjects(lang);
    // Retourner seulement les projets featured
    return allProjects.filter(p => p.featured);
};

// Export of the getters for use with translations.
// NOTE: the previous eager `export const featuredProjects = getFeaturedProjects('fr')`
// executed at import time in every bundle that touched this module and dragged the
// full project + icon dataset into client chunks. It was unused, so it is gone.
export { getFeaturedProjects, getAllProjects, getSkills, getProjectById };

// Function to get a single project by ID
const getProjectById = (id: number, lang: 'fr' | 'en' = 'fr') => {
    return getAllProjects(lang).find((project) => project.id === id);
};